import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { resultsDisclaimer } from "../../data/site";
import { SiteLink } from "../SiteLink";
export function CaseResult() {
  return <section id="case-result" aria-labelledby="result-title" className="on-dark bg-ink text-white" data-id="element-149" data-mp="il6rxzgqdygr">
      <div className="page-container grid gap-8 py-12 md:py-16 lg:grid-cols-12 lg:gap-16" data-id="element-150" data-mp="nbdhc1j2hn02">
        <div className="lg:col-span-5" data-id="element-151" data-mp="saqaf40j7qb3">
          <p className="text-label font-semibold text-white/80" data-id="element-152" data-mp="s9yfzwio7yme">Kent County, Michigan · May 3, 2024</p>
          <h2 id="result-title" className="mt-4 text-[48px] font-extrabold leading-[1.1] tracking-tight sm:text-[64px]" data-id="element-153" data-mp="x8i2pz539eft">
            $27.5 million
            <span className="mt-3 block text-h3 font-bold tracking-normal" data-id="element-154" data-mp="16aiyerkobsfd">Motorcycle injury jury verdict</span>
          </h2>
          <p className="mt-5 max-w-measure text-meta text-white/80" data-id="element-155" data-mp="333kt34sfpnso">
            The firm’s case report describes it as Michigan’s largest motorcycle injury verdict, based on its research.
          </p>
          <p className="mt-5 max-w-measure border-t border-white/25 pt-4 text-meta text-white/80" data-id="element-156" data-mp="240wl1a45e7ih">
            {resultsDisclaimer}
          </p>
        </div>
        <div className="border-t border-white/25 pt-7 lg:col-span-7 lg:border-l lg:border-t-0 lg:pl-12 lg:pt-0" data-id="element-157" data-mp="1z83fwl4rox5v">
          <h3 className="text-h3 font-bold" data-id="element-158" data-mp="1q988j5pzlh0z">Holding a distracted driver accountable</h3>
          <p className="mt-4 max-w-measure text-white/90" data-id="element-159" data-mp="1q7f5s1ihvgy9">
            A driver using a phone app crossed the centerline and struck a rider, whose injuries included a leg amputation.
            Jason Waechter led the trial team for the rider and his wife, pursuing claims against the driver and her employer.
          </p>
          <SiteLink path="/27-million-motorcycle-injury-verdict/" className="mt-5 inline-flex min-h-[48px] items-center gap-2 text-label font-bold text-white underline underline-offset-4 hover:decoration-2" data-id="element-160" data-mp="29097htr3xckj">
            Read how the case was won
            <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0" data-id="element-161" data-mp="xj9gr2ker5sm" />
          </SiteLink>
        </div>
      </div>
    </section>;
}